export default {
  getPodcast: {},
  getAllPodcast: {},
  getCategory: {},
  getAllCategory: {},
  getEpisode: {},
  getAllEpisode: {},
  selectedPodcast: {},
  selectedCategory: {},
  selectedEpisode: {},
  getAllHistory: {},
  // getAllForm: {},
};
